import React, { useContext, useEffect, useState } from "react";
// import Pagereview from "../../components/pageReview/Pagereview";
import { FiArrowRightCircle } from "react-icons/fi";
import {
  EventVariantCard,
  PaginationRenderer,
} from "../CMSRenderer/components";
import { getNews } from "../../utils/apiCalls";
import moment from "moment";
import { FormContext } from "../CMSRenderer/CMSRenderer";
import "moment/locale/ar";

const MediaCenter = ({ config }) => {
  const { currentLang } = useContext(FormContext);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    currentPage: 1,
    totalPage: 1,
    totalItems: 0,
  });
  const [newsData, setNewsData] = useState([]);

  useEffect(() => {
    getNews({
      page: pagination?.currentPage || 1,
      pageSize: pagination?.pageSize || 10,
    }).then((res) => {
      setPagination({
        ...pagination,
        pageSize: res?.pagination?.pageSize || 10,
        totalPage: res?.pagination?.totalPages || 1,
        totalItems: res?.pagination?.total || 0,
      });
      setNewsData(res?.data || []);
    });
  }, [pagination?.currentPage]);

  return (
    <>
      {/* <dda-breadcrumb
        design="text"
        separator="chevron_right"
        custom_class=""
        component_mode=""
        data-breadcrumbs='[{"text":"Home","icon":"home","url":"/"},{"text":"Media Center","icon":"menu_book","url":"/mediaCenter"}]'
      ></dda-breadcrumb> */}
      <h2 className="mb-4 Medium text-primary">
        {currentLang === "en" ? config.title : config.title_ar}
      </h2>
      {newsData?.length > 0 && (
        <a
          href={`/mediaCenter/mediaCenterDetails/${newsData?.[0]?.dguid || ""}`}
          className="cursor-pointer"
        >
          <div className="md:flex bg-[#ADADAD]/10 rounded-xl hover:shadow-md transition-all">
            <div className="md:w-1/3">
              <img
                src={"/" + newsData?.[0]?.image || ""}
                alt="news image"
                className="md:rounded-s-xl md:rounded-se-none rounded-t-xl md:h-full h-[200px] w-full object-cover"
              />
            </div>
            <div className="md:w-2/3 p-5 flex flex-col justify-around gap-2">
              <div className="flex justify-between gap-6">
                <h5 className="text-primary">
                  {currentLang === "en"
                    ? newsData?.[0]?.titleEn
                    : newsData?.[0]?.titleAr || ""}
                </h5>
                <FiArrowRightCircle className="text-primary text-2xl shrink-0" />
              </div>
              <p className="body text-onSurfaceVariant">
                {currentLang === "en"
                  ? newsData?.[0]?.shortDescriptionEn
                  : newsData?.[0]?.shortDescriptionAr || ""}
              </p>
              <p className="capton">
                {moment(new Date(newsData?.[0]?.publishDate))
                  ?.locale(currentLang === "en" ? "en" : "ar")
                  .format("dddd, MMMM DD, YYYY")
                  .replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d))
                  .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d)) || ""}
              </p>
            </div>
          </div>
        </a>
      )}

      <div className="mt-8 grid lg:grid-cols-3 sm:grid-cols-2 gap-8">
        {newsData?.length > 0 &&
          newsData?.slice(1)?.map((news, index) => (
            <>
              <EventVariantCard
                image={"/" + news?.image || ""}
                key={index}
                date={{
                  month:
                    moment(new Date(news.publishDate))
                      ?.locale(currentLang === "en" ? "en" : "ar")
                      .format("MMM") || "",
                  day:
                    moment(new Date(news.publishDate))
                      ?.locale(currentLang === "en" ? "en" : "en")
                      .format("DD") || "",
                }}
                title={currentLang === "en" ? news?.titleEn : news?.titleAr}
                description={
                  currentLang === "en"
                    ? news?.shortDescriptionEn
                    : news?.shortDescriptionAr
                }
                link={`/mediaCenter/mediaCenterDetails/${news?.dguid || ""}`}
              />
            </>
          ))}
      </div>
      <PaginationRenderer
        totalPage={pagination?.totalPage}
        currentPage={pagination?.currentPage}
        handlePage={(e) =>
          setPagination({
            ...pagination,
            currentPage: e,
          })
        }
        pageSize={pagination?.pageSize}
        totalItems={pagination?.totalItems}
        currentLang={currentLang}
      />
      {/* <Pagereview /> */}
    </>
  );
};

const NewsDetail = ({ config }) => {
  const { currentLang } = useContext(FormContext);
  return (
    <>
      <dda-breadcrumb
        design="text"
        separator="chevron_right"
        custom_class=""
        component_mode=""
        data-breadcrumbs='[{"text":"Home","icon":"home","url":"/"},{"text":"News Details","icon":"menu_book","url":""}]'
      ></dda-breadcrumb>
      <h2 className="md:!my-4 my-2 Medium text-primary">News Details</h2>

      <div className="lg:flex rounded-2xl  items-center gap-8">
        <img
          src={"/assets/images/mediaCenter.png"}
          alt="news img"
          className="lg:w-1/3 lg:max-h-none max-h-[200px] w-full object-cover rounded-xl"
        />
        <div className="flex-1 lg:mt-0 mt-3">
          <p className="text-primary p-2 bg-customSurface w-fit rounded-lg">
            Monday, November 18, 2024
          </p>
          <h6 className="lg:my-7 my-4 Medium">
            Dubai Health Authority Launches Professional Diploma Programme for
            Health Facility Inspectors in Collaboration with Sharjah University
          </h6>

          {/* <div className="flex md:gap-4 gap-2">
            <a href="#" target="_blank" rel="noopener noreferrer">
              <FaTwitter className="text-primary text-2xl" />
            </a>
            <a href="#" target="_blank" rel="noopener noreferrer">
              <FaFacebook className="text-primary text-2xl" />
            </a>
            <a href="#" target="_blank" rel="noopener noreferrer">
              <FaLinkedin className="text-primary text-2xl" />
            </a>
            <a href="#" target="_blank" rel="noopener noreferrer">
              <FaInstagram className="text-primary text-2xl" />
            </a>
            <a href="#" target="_blank" rel="noopener noreferrer">
              <FiDownload className="text-primary text-2xl" />
            </a>
          </div> */}
        </div>
      </div>

      <div className="md:!my-6 my-4 text-onSurfaceVariant body">
        <p className="md:!my-6 my-4 text-onSurfaceVariant body">
          Dubai, UAE, 28 November 2024: HE Awadh Seghayer Al Ketbi, Director
          General of Dubai Health Authority (DHA), has inaugurated the renovated
          hospital in the presence of Saleh Al Hashimi, CEO of Dubai Health
          Insurance Corporation at the DHA, Mr. Aidroos Hassan Omar Alesayi,
          Chairman and Mr. Paul Gregersen, CEO of International Modern Hospital
          and other senior officials.
          <br />
          During the inauguration, HE Al Ketbi spoke about the rapid development
          witnessed by the healthcare sector in Dubai in line with the
          initiatives implemented by the DHA. “We ensure that the healthcare
          facilities keep up with the high demand for medical services by
          expanding their portfolios, specialities and the quality of their
          services.”
        </p>
      </div>
    </>
  );
};

export default MediaCenter;
